
// SVG Icon: ar-hover2
export default { id: "terriajs-ar-hover2" };
export const id = "terriajs-ar-hover2";
export const name = "ar-hover2";
